import { UserDataContract, UserPreferenceContract } from 'models'
import {
    getUserDataActionSet,
    LOGOUT_SUCCESS,
    UPDATE_USERPREFERENCE_BEGIN,
    UPDATE_USERPREFERENCE_SUCCESS,
    UPDATE_USERPREFERENCE_FAILURE,
    AUTH_EXPIRED,
    SHOW_FORCE_LOGOUT_DIALOG,
    COMPLETE_FETCH_FULL_ACCESS_TOKEN,
    COMPLETE_FETCH_PERMISSION,
} from 'store/actions/auth.action'
import {
    AuthState,
    AuthorizationState,
    ValidateTokenResult,
} from 'store/models/authModels'
import { IAction } from 'types/storeTypes'

export const VALIDATE_TOKEN_BEGIN = 'VALIDATE_TOKEN_BEGIN'
export const VALIDATE_REAL_CLIENT_TOKEN_SUCCESS =
    'VALIDATE_REAL_CLIENT_TOKEN_SUCCESS'
export const VALIDATE_NON_CLIENT_TOKEN_SUCCESS =
    'VALIDATE_NON_CLIENT_TOKEN_SUCCESS'
export const VALIDATE_TOKEN_FAILURE = 'VALIDATE_TOKEN_FAILURE'
export const NO_TOKEN = 'NO_TOKEN'

/**
 * Auth State
 * PREPARE --> PROCESSING
 * PROCESSING --> SUCCESS | SUCCESS_NON_CLIENT | ERROR_AUTH | ERROR
 */
const initialState: AuthState = {
    isAuthExpired: false,
    isLoggedOut: false,
    authExpireMessage: '',
    user: null,
    authState: AuthorizationState.PREPARE,
    editUserLoading: false,
    errorUserData: null,
    actionCodes: [],
    showForceLogoutDialog: false,
}

function Auth(state: AuthState = initialState, action: IAction): AuthState {
    switch (action.type) {
        case AUTH_EXPIRED:
            return {
                ...state,
                isAuthExpired: true,
                authExpireMessage: action.payload,
                authState: AuthorizationState.EXPIRED,
            }
        case LOGOUT_SUCCESS:
            return {
                ...state,
                authState: AuthorizationState.PREPARE,
                isLoggedOut: true,
                actionCodes: [],
                isAuthExpired: false,
                user: null,
            }
        case VALIDATE_TOKEN_BEGIN:
            return {
                ...state,
                authState: AuthorizationState.PROCESSING,
                isAuthExpired: false,
            }
        case VALIDATE_NON_CLIENT_TOKEN_SUCCESS: {
            return {
                ...state,
                authState: AuthorizationState.SUCCESS_NON_CLIENT,
            }
        }
        case VALIDATE_REAL_CLIENT_TOKEN_SUCCESS:
            const payload = action.payload as ValidateTokenResult
            return {
                ...state,
                authState: AuthorizationState.SUCCESS_REAL_CLIENT,
                user: payload.user,
                isLoggedOut: false,
            }
        case VALIDATE_TOKEN_FAILURE:
            return {
                ...state,
                authState: AuthorizationState.ERROR_AUTH,
                actionCodes: [],
            }
        case NO_TOKEN: {
            return {
                ...state,
                authState: AuthorizationState.ERROR_AUTH,
            }
        }
        case COMPLETE_FETCH_PERMISSION: {
            return {
                ...state,
                actionCodes: action.payload.actionCodes,
            }
        }
        /** Call when complete login flow **/
        case COMPLETE_FETCH_FULL_ACCESS_TOKEN: {
            return {
                ...state,
                authState: AuthorizationState.SUCCESS_REAL_CLIENT,
                // actionCodes: action.payload.actionCodes,
                user: action.payload.user,
                isLoggedOut: false,
            }
        }
        case getUserDataActionSet.onPending:
            return {
                ...state,
                errorUserData: null,
            }
        case getUserDataActionSet.onSuccess:
            return {
                ...state,
                user: action.payload,
            }
        case getUserDataActionSet.onFailed:
            return {
                ...state,
                errorUserData:
                    (action.payload as Error)?.message ??
                    'Error while fetching user data',
            }
        case UPDATE_USERPREFERENCE_BEGIN:
            return {
                ...state,
                editUserLoading: true,
                errorUserData: null,
            }
        case UPDATE_USERPREFERENCE_SUCCESS:
            var user: UserDataContract = {
                ...(state.user ?? {
                    userPreference: undefined,
                }),
            }
            user.userPreference = action.payload as UserPreferenceContract

            return {
                ...state,
                editUserLoading: false,
                user: user,
            }
        case UPDATE_USERPREFERENCE_FAILURE:
            return {
                ...state,
                editUserLoading: false,
                errorUserData:
                    (action.payload as Error)?.message ??
                    'UPDATE_USERPREFERENCE_FAILURE',
            }
        case SHOW_FORCE_LOGOUT_DIALOG:
            return {
                ...state,
                showForceLogoutDialog: true,
                user: null, // clear user when force logout
            }
        default:
            return state
    }
}

export default Auth
